import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MD5Service {
  private _hex_chr = '0123456789abcdef'.split('');

  public hash(string: string): string {
    return this._hex(this._md51(string));
  }

  private _md5cycle(x, k) {
    let a = x[0],
      b = x[1],
      c = x[2],
      d = x[3];

    a = this._ff(a, b, c, d, k[0], 7, -680876936);
    d = this._ff(d, a, b, c, k[1], 12, -389564586);
    c = this._ff(c, d, a, b, k[2], 17, 606105819);
    b = this._ff(b, c, d, a, k[3], 22, -1044525330);
    a = this._ff(a, b, c, d, k[4], 7, -176418897);
    d = this._ff(d, a, b, c, k[5], 12, 1200080426);
    c = this._ff(c, d, a, b, k[6], 17, -1473231341);
    b = this._ff(b, c, d, a, k[7], 22, -45705983);
    a = this._ff(a, b, c, d, k[8], 7, 1770035416);
    d = this._ff(d, a, b, c, k[9], 12, -1958414417);
    c = this._ff(c, d, a, b, k[10], 17, -42063);
    b = this._ff(b, c, d, a, k[11], 22, -1990404162);
    a = this._ff(a, b, c, d, k[12], 7, 1804603682);
    d = this._ff(d, a, b, c, k[13], 12, -40341101);
    c = this._ff(c, d, a, b, k[14], 17, -1502002290);
    b = this._ff(b, c, d, a, k[15], 22, 1236535329);

    a = this._gg(a, b, c, d, k[1], 5, -165796510);
    d = this._gg(d, a, b, c, k[6], 9, -1069501632);
    c = this._gg(c, d, a, b, k[11], 14, 643717713);
    b = this._gg(b, c, d, a, k[0], 20, -373897302);
    a = this._gg(a, b, c, d, k[5], 5, -701558691);
    d = this._gg(d, a, b, c, k[10], 9, 38016083);
    c = this._gg(c, d, a, b, k[15], 14, -660478335);
    b = this._gg(b, c, d, a, k[4], 20, -405537848);
    a = this._gg(a, b, c, d, k[9], 5, 568446438);
    d = this._gg(d, a, b, c, k[14], 9, -1019803690);
    c = this._gg(c, d, a, b, k[3], 14, -187363961);
    b = this._gg(b, c, d, a, k[8], 20, 1163531501);
    a = this._gg(a, b, c, d, k[13], 5, -1444681467);
    d = this._gg(d, a, b, c, k[2], 9, -51403784);
    c = this._gg(c, d, a, b, k[7], 14, 1735328473);
    b = this._gg(b, c, d, a, k[12], 20, -1926607734);

    a = this._hh(a, b, c, d, k[5], 4, -378558);
    d = this._hh(d, a, b, c, k[8], 11, -2022574463);
    c = this._hh(c, d, a, b, k[11], 16, 1839030562);
    b = this._hh(b, c, d, a, k[14], 23, -35309556);
    a = this._hh(a, b, c, d, k[1], 4, -1530992060);
    d = this._hh(d, a, b, c, k[4], 11, 1272893353);
    c = this._hh(c, d, a, b, k[7], 16, -155497632);
    b = this._hh(b, c, d, a, k[10], 23, -1094730640);
    a = this._hh(a, b, c, d, k[13], 4, 681279174);
    d = this._hh(d, a, b, c, k[0], 11, -358537222);
    c = this._hh(c, d, a, b, k[3], 16, -722521979);
    b = this._hh(b, c, d, a, k[6], 23, 76029189);
    a = this._hh(a, b, c, d, k[9], 4, -640364487);
    d = this._hh(d, a, b, c, k[12], 11, -421815835);
    c = this._hh(c, d, a, b, k[15], 16, 530742520);
    b = this._hh(b, c, d, a, k[2], 23, -995338651);

    a = this._ii(a, b, c, d, k[0], 6, -198630844);
    d = this._ii(d, a, b, c, k[7], 10, 1126891415);
    c = this._ii(c, d, a, b, k[14], 15, -1416354905);
    b = this._ii(b, c, d, a, k[5], 21, -57434055);
    a = this._ii(a, b, c, d, k[12], 6, 1700485571);
    d = this._ii(d, a, b, c, k[3], 10, -1894986606);
    c = this._ii(c, d, a, b, k[10], 15, -1051523);
    b = this._ii(b, c, d, a, k[1], 21, -2054922799);
    a = this._ii(a, b, c, d, k[8], 6, 1873313359);
    d = this._ii(d, a, b, c, k[15], 10, -30611744);
    c = this._ii(c, d, a, b, k[6], 15, -1560198380);
    b = this._ii(b, c, d, a, k[13], 21, 1309151649);
    a = this._ii(a, b, c, d, k[4], 6, -145523070);
    d = this._ii(d, a, b, c, k[11], 10, -1120210379);
    c = this._ii(c, d, a, b, k[2], 15, 718787259);
    b = this._ii(b, c, d, a, k[9], 21, -343485551);

    x[0] = this._add32(a, x[0]);
    x[1] = this._add32(b, x[1]);
    x[2] = this._add32(c, x[2]);
    x[3] = this._add32(d, x[3]);
  }

  private _cmn(q, a, b, x, s, t) {
    a = this._add32(this._add32(a, q), this._add32(x, t));
    return this._add32((a << s) | (a >>> (32 - s)), b);
  }

  private _ff(a, b, c, d, x, s, t) {
    return this._cmn((b & c) | (~b & d), a, b, x, s, t);
  }

  private _gg(a, b, c, d, x, s, t) {
    return this._cmn((b & d) | (c & ~d), a, b, x, s, t);
  }

  private _hh(a, b, c, d, x, s, t) {
    return this._cmn(b ^ c ^ d, a, b, x, s, t);
  }

  private _ii(a, b, c, d, x, s, t) {
    return this._cmn(c ^ (b | ~d), a, b, x, s, t);
  }

  private _md51(s) {
    const n = s.length,
      state = [1732584193, -271733879, -1732584194, 271733878];
    const tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    let i;

    for (i = 64; i <= s.length; i += 64) {
      this._md5cycle(state, this._md5blk(s.substring(i - 64, i)));
    }

    s = s.substring(i - 64);

    for (i = 0; i < s.length; i++)
      tail[i >> 2] |= s.charCodeAt(i) << (i % 4 << 3);
    tail[i >> 2] |= 0x80 << (i % 4 << 3);
    if (i > 55) {
      this._md5cycle(state, tail);
      for (i = 0; i < 16; i++) tail[i] = 0;
    }
    tail[14] = n * 8;
    this._md5cycle(state, tail);
    return state;
  }

  private _md5blk(s) {
    const md5blks = [];
    for (let i = 0; i < 64; i += 4) {
      md5blks[i >> 2] =
        s.charCodeAt(i) +
        (s.charCodeAt(i + 1) << 8) +
        (s.charCodeAt(i + 2) << 16) +
        (s.charCodeAt(i + 3) << 24);
    }
    return md5blks;
  }

  private _rHex(n) {
    let s = '',
      j = 0;

    for (; j < 4; j++)
      s +=
        this._hex_chr[(n >> (j * 8 + 4)) & 0x0f] +
        this._hex_chr[(n >> (j * 8)) & 0x0f];
    return s;
  }

  private _hex(x) {
    for (let i = 0; i < x.length; i++) x[i] = this._rHex(x[i]);
    return x.join('');
  }

  private _add32(a, b) {
    return (a + b) & 0xffffffff;
  }
}
